import React from "react";
import Sense from "components/Tiles/Sense/Sense";
import SenseTile from "components/Tiles/Sense/SenseTile";
const SenseViewContainer = ({ forceDatasetIds }) => {
    if (forceDatasetIds) {
        return (React.createElement(React.Fragment, null, forceDatasetIds.map((id) => (React.createElement("div", { style: { marginRight: "20px", height: "100%" }, key: "force_dataset_" + id },
            React.createElement(SenseTile, { id: id }))))));
    }
    return (React.createElement("div", { style: { height: "100%", width: "100%", display: "flex" } },
        React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement(Sense, null))));
};
export default SenseViewContainer;
